export const buildPlotLines = (viewMode, itemsPerSet) => {
  if (viewMode === 'varyingProbability') return [100 / (itemsPerSet || 4)]

  if (viewMode === 'probability') return [50]

  return
}
